export const baseIsMobile = {
  computed: {
    isTablet() {
      return ['md', 'xs', 'sm'].indexOf(this.$root.$mq) !== -1;
    },
    isTabletOnly() {
      return ['md'].indexOf(this.$root.$mq) !== -1;
    },
    isMobile() {
      return ['xs', 'sm'].indexOf(this.$root.$mq) !== -1;
    },
    isXsMobile() {
      return ['xs'].indexOf(this.$root.$mq) !== -1;
    },
  }
}